module.exports = __webpack_public_path__ + "img/qiche.bdc18c54.png";